import IProcessConfig from '@/Domain/interfaces/IProcessConfig';
import MultiLanguage from '../MultiLanguage';

export default abstract class ProcessConfig implements IProcessConfig {
   id: string;
   title: MultiLanguage;
   isEditable: boolean;
   type!: BigInt;
   maxLength: number | undefined;
   filterMinimumValidType: BigInt;
   active: boolean;

   public constructor(data: any) {
      this.id = data.id;
      this.title = new MultiLanguage(data.title);
      this.isEditable = data.isEditable;
      this.filterMinimumValidType =  BigInt(0);
      this.active = data.active !== undefined ? data.active : true;
   }

   toServer() {
      return {};
   }
}
